import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row p-2 text-center" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "w-100",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restart && _ctx.restart(...args)))
      }, "Restart")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "w-100",
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)))
      }, "Start")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "w-100",
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
      }, "Stop")
    ])
  ]))
}